module.exports = __webpack_public_path__ + "img/return-icon.c25d5365.svg";